import { usePathwayTemplates } from '@/stores/pathwayTemplatesStore';
import { numberFormat, unitToString } from '@/utils/unitUtils';
import { useParams } from 'react-router';
import { confirm } from '@/components/core/createConfirmation';
import { createPathwayForTemplate, getPathways } from '@/api/pathways';
import { toast } from '@/utils/toast';
import { resourcesActions } from '@/stores/resourcesStore';

const PathwayTemplates = () => {
  const pathwayTemplates = usePathwayTemplates();
  const { projectId } = useParams();

  const handleCreateFromTemplate = async (templateId: string) => {
    const ok = await confirm('Are you sure want to create a new pathway from this template?');
    if (!ok) return;

    try {
      toast.info('Creating new pathway from template. Please wait...');
      await createPathwayForTemplate({ project_id: projectId, template_ids: [templateId] });
      const pathways = await getPathways(projectId);
      resourcesActions.setPathways(pathways.data);
      toast.success('New pathway has been created successfully');
    } catch (err) {
    }
  };

  return (
    <div className="mb-6">
      <p className="text-lg font-semibold">Pathway Templates ({pathwayTemplates.length})</p>
      <p className="text-sm text-gray-600 mt-2 pb-2 border-b border-gray-200">
        Select a pre-configured pathway template to get started with your analysis. These templates contain optimized parameters and configurations for common industrial decarbonization scenarios.
      </p>
      <div className="mt-4">
        <table className="w-full text-left text-sm border-collapse">
          <thead className="bg-white">
            <tr className="border-b">
              <th className="py-2 px-4 font-medium">Name</th>
              <th className="py-2 px-4 font-medium">Feedstocks</th>
              <th className="py-2 px-4 font-medium">Cost</th>
              <th className="py-2 px-4 font-medium">Emissions</th>
            </tr>
          </thead>
          <tbody>
            {pathwayTemplates.map((template: any, index: number) => (
              <tr
                key={index}
                className="border-b hover:bg-gray-50 text-sm cursor-pointer"
                onClick={() => handleCreateFromTemplate(template.id)}
              >
                <td className="py-3 px-4">{template.name}</td>
                <td className="py-3 px-4">{template?.feedstocks?.join(', ')}</td>
                <td className="py-3 px-4 font-bold">
                  {template.cost?.scalar && template.cost?.unit
                    ? `${numberFormat(template.cost.scalar)} ${unitToString(template.cost.unit)}`
                    : 'N/A'}
                </td>
                <td className="py-3 px-4 font-bold">
                  {template.emissions?.scalar && template.emissions?.unit
                    ? `${numberFormat(template.emissions.scalar)} ${unitToString(template.emissions.unit)}`
                    : 'N/A'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PathwayTemplates;


